import { FC } from 'react';
import styled from 'styled-components';
import { getDollarAmountText } from '../../../../../services/utils/FormatHelper';
import { theme } from '../../../../../styles/theme';
import { Icon, Typography } from '../../../../style';
import { ContractDataProps } from '../contract-modal/ContractDetails';
import { dateUpdate } from '../customer-modal/DateFormat';
import { StyledRow } from './Style';

const TermDetails: FC<ContractDataProps> = (props) => {
  const dealType = props.data.dealType;
  const isContractPaidOff = props.data.isPaidOff;

  return (
    <Border data-testid='term-details-border'>
      <Wrapper data-testid='term-details-table'>
        <tbody>
          {dealType === 'Finance' && isContractPaidOff ? (
            <StyledRow>
              <td className='col-sm-8'>
                <div className='d-flex'>
                  <Icon
                    className='term-details contract-not-paid-off-icon me-2'
                    type='checkmark'
                    data-testid='contract-paid-off-icon'
                    size={18}
                    color={theme.palette.success}
                  ></Icon>
                  <Typography
                    size={theme.typography.h5}
                    fontWeight={theme.typography.fontWeights.semibold}
                    color={theme.palette.wetAsphalt}
                  >
                    Contract paid off
                  </Typography>
                </div>
              </td>
            </StyledRow>
          ) : dealType === 'Finance' && !isContractPaidOff ? (
            <StyledRow>
              <td className='col-sm-8'>
                <div>
                  <Icon
                    className='term-details-plaintext calendar-icon me-2'
                    type='stop'
                    data-testid='contract-not-paid-off-icon'
                    size={15}
                    color={theme.palette.basicGray}
                  ></Icon>
                  <Typography
                    size={theme.typography.h5}
                    fontWeight={theme.typography.fontWeights.semibold}
                    color={theme.palette.wetAsphalt}
                  >
                    Contract not paid off
                  </Typography>
                </div>
              </td>
            </StyledRow>
          ) : (
            <></>
          )}
          <StyledRow>
            <td className='col-sm-3'>
              <Typography
                size={theme.typography.h5}
                fontWeight={theme.typography.fontWeights.semibold}
                color={theme.palette.wetAsphalt}
              >
                Contract Start
              </Typography>
            </td>
            {dealType !== 'Cash' && (
              <td className='col-sm-3'>
                <Typography
                  size={theme.typography.h5}
                  fontWeight={theme.typography.fontWeights.semibold}
                  color={theme.palette.wetAsphalt}
                >
                  Contract End
                </Typography>
              </td>
            )}
            {dealType !== 'Cash' && (
              <td className='col-sm-3'>
                <Typography
                  size={theme.typography.h5}
                  fontWeight={theme.typography.fontWeights.semibold}
                  color={theme.palette.wetAsphalt}
                >
                  Term
                </Typography>
              </td>
            )}
            {dealType === 'Cash' ? (
              <td className='col-sm-3'>
                <Typography
                  size={theme.typography.h5}
                  fontWeight={theme.typography.fontWeights.semibold}
                  color={theme.palette.wetAsphalt}
                >
                  Total Payment
                </Typography>
              </td>
            ) : dealType === 'Finance' ? (
              <td className='col-sm-3'>
                <Typography
                  size={theme.typography.h5}
                  fontWeight={theme.typography.fontWeights.semibold}
                  color={theme.palette.wetAsphalt}
                >
                  Retail Payment
                </Typography>
              </td>
            ) : (
              <td className='col-sm-3'>
                <Typography
                  size={theme.typography.h5}
                  fontWeight={theme.typography.fontWeights.semibold}
                  color={theme.palette.wetAsphalt}
                >
                  {dealType + ' Payment'}
                </Typography>
              </td>
            )}
            {dealType === 'Cash' && (
              <td className='col-sm-6'>
                <Typography
                  size={theme.typography.h5}
                  fontWeight={theme.typography.fontWeights.semibold}
                  color={theme.palette.wetAsphalt}
                >
                  Selling Price
                </Typography>
              </td>
            )}
          </StyledRow>
          <StyledRow>
            <td className='col-sm-3'>
              <Icon
                className='term-details-plaintext calendar-icon'
                type='calendar'
                data-testid='start-date-calendar-icon'
                size={15}
                color={theme.palette.dusty}
              >
                &nbsp;
              </Icon>
              <Typography
                size={theme.typography.h4}
                fontWeight={theme.typography.fontWeights.normal}
                color={theme.palette.grey}
              >
                {props.data.dealDate ? dateUpdate(props.data.dealDate) : 'N/A'}
              </Typography>
            </td>
            {dealType !== 'Cash' && (
              <td className='col-sm-3'>
                <Icon
                  className='term-details-plaintext calendar-icon'
                  type='calendar'
                  data-testid='end-date-calendar-icon'
                  size={15}
                  color={theme.palette.dusty}
                >
                  &nbsp;
                </Icon>
                <Typography
                  size={theme.typography.h4}
                  fontWeight={theme.typography.fontWeights.normal}
                  color={theme.palette.grey}
                >
                  {props.data.endDate ? dateUpdate(props.data.endDate) : 'N/A'}
                </Typography>
              </td>
            )}
            {dealType !== 'Cash' && (
              <td className='col-sm-3'>
                <Typography
                  size={theme.typography.h4}
                  fontWeight={theme.typography.fontWeights.normal}
                  color={theme.palette.grey}
                >
                  {props.data.term
                    ? props.data.term == 1
                      ? props.data.term + ' Month'
                      : props.data.term + ' Months'
                    : '0 Month'}
                </Typography>
              </td>
            )}
            {dealType === 'Cash' ? (
              <td className='col-sm-3'>
                <Typography
                  size={theme.typography.h4}
                  fontWeight={theme.typography.fontWeights.semibold}
                  color={theme.palette.basicGray}
                >
                  $&nbsp;
                </Typography>
                <Typography
                  size={theme.typography.h4}
                  fontWeight={theme.typography.fontWeights.normal}
                  color={theme.palette.grey}
                >
                  {getDollarAmountText(props.data.downPayment ? props.data.downPayment : 0)}
                </Typography>
              </td>
            ) : dealType === 'Finance' ? (
              <td className='col-sm-3'>
                <Typography
                  size={theme.typography.h4}
                  fontWeight={theme.typography.fontWeights.semibold}
                  color={theme.palette.basicGray}
                >
                  $&nbsp;
                </Typography>
                <Typography
                  size={theme.typography.h4}
                  fontWeight={theme.typography.fontWeights.normal}
                  color={theme.palette.grey}
                >
                  {getDollarAmountText(props.data.payment ? props.data.payment : 0)}
                </Typography>
              </td>
            ) : (
              <td className='col-sm-3'>
                <Typography
                  size={theme.typography.h4}
                  fontWeight={theme.typography.fontWeights.semibold}
                  color={theme.palette.basicGray}
                >
                  $&nbsp;
                </Typography>
                <Typography
                  size={theme.typography.h4}
                  fontWeight={theme.typography.fontWeights.normal}
                  color={theme.palette.grey}
                >
                  {getDollarAmountText(props.data.payment ? props.data.payment : 0)}
                </Typography>
              </td>
            )}
            {dealType === 'Cash' && (
              <td className='col-sm-6'>
                <Typography
                  size={theme.typography.h4}
                  fontWeight={theme.typography.fontWeights.semibold}
                  color={theme.palette.basicGray}
                >
                  $&nbsp;
                </Typography>
                <Typography
                  size={theme.typography.h4}
                  fontWeight={theme.typography.fontWeights.normal}
                  color={theme.palette.grey}
                >
                  {getDollarAmountText(props.data.cashPrice ? props.data.cashPrice : 0)}
                </Typography>
              </td>
            )}
          </StyledRow>
        </tbody>
      </Wrapper>
    </Border>
  );
};

export default TermDetails;

const Wrapper = styled.table`
  padding: 20px;
  display: flex;
  flex-direction: column;
  & tr {
    padding-top: 10px;
    line-height: 26px;
  }
  & tr:last-child {
    padding-top: 5px;
  }
  .me-2 {
    margin-right: 7px;
  }
`;

const Border = styled.div`
  border-bottom: 2px dashed ${theme.palette.lightGrey};
`;
